import { OnInit, ChangeDetectorRef } from '@angular/core';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { Constants } from '../../../shared/config/constants.config';
import { ActivatedRoute, Router } from '@angular/router';
import { StarsService } from '../../../shared/services/stars.service';
import { forkJoin } from 'rxjs';
import { StorageService } from '../../../shared/services/storage.service';
import { UsersService } from '../../../shared/services/users.service';
import { BsModalService } from 'ngx-bootstrap';
import { BsModalEventsEmitter } from '../../../shared/events/bsModal.events';
import { AddAddonComponentModalComponent } from '../add-addon/add-addon.component';
import { LocalisationService } from '../../../shared/services/localisation.service';
var StarsSingleComponent = /** @class */ (function () {
    function StarsSingleComponent(starsService, changeDetectorRef, appLoadingEventsEmitter, localStorage, usersService, localisationService, route, constants, router, bsModalService, bsModalEventsEmitter) {
        this.starsService = starsService;
        this.changeDetectorRef = changeDetectorRef;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.localStorage = localStorage;
        this.usersService = usersService;
        this.localisationService = localisationService;
        this.route = route;
        this.constants = constants;
        this.router = router;
        this.bsModalService = bsModalService;
        this.bsModalEventsEmitter = bsModalEventsEmitter;
        this.recipes = [];
        this.influencerInSubscription = false;
        this.hasSubscription = false;
    }
    StarsSingleComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.route.params.subscribe(function (params) {
            forkJoin([
                _this.starsService.getInfluencerById(params['id']),
                _this.starsService.getRecipesByInfluencerId(params['id'])
            ]).subscribe(function (_a) {
                var influencer = _a[0], recipes = _a[1];
                _this.influencer = influencer;
                _this.recipes = recipes;
                _this.usersService.getUserSubscription().subscribe(function (subscription) {
                    if (parseFloat(subscription.pricing_plan.amounts[0].monthly_price) > 0) {
                        _this.hasSubscription = true;
                    }
                    else {
                        _this.hasSubscription = false;
                    }
                    _this.changeDetectorRef.markForCheck();
                }, function () {
                    _this.hasSubscription = false;
                    _this.changeDetectorRef.markForCheck();
                });
                _this.starsService.isInfluencerInSubscription(params['id']).subscribe(function () {
                    _this.influencerInSubscription = true;
                    _this.changeDetectorRef.markForCheck();
                }, function () {
                    _this.influencerInSubscription = false;
                    _this.changeDetectorRef.markForCheck();
                });
                _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                _this.changeDetectorRef.markForCheck();
            });
        });
    };
    StarsSingleComponent.prototype.openLink = function (link) {
        window.open(link, '_blank');
    };
    StarsSingleComponent.prototype.buyInfluencerRecipes = function (id) {
        if (this.influencerInSubscription === true) {
            return null;
        }
        this.localStorage.setItem('star', id);
        if (this.hasSubscription === false) {
            this.router.navigate(['pricing']);
        }
        else {
            this.bsModalRef = this.bsModalService.show(AddAddonComponentModalComponent, {
                backdrop: true
            });
            this.bsModalRef.content.influencer = this.influencer;
            this.bsModalRef.content.starsSingle = this;
            this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
        }
    };
    StarsSingleComponent.prototype.removeFromSubscriptionInfluencerRecipes = function (influencer_id) {
        var _this = this;
        if (confirm(this.localisationService.localise('dashboard_cancel_subscription_confirmation'))) {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
            this.starsService.removeInfluencerFromSubscription(influencer_id).subscribe(function () {
                _this.influencerInSubscription = false;
                _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                _this.changeDetectorRef.markForCheck();
            }, function () {
                _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                _this.changeDetectorRef.markForCheck();
            });
        }
    };
    return StarsSingleComponent;
}());
export { StarsSingleComponent };
